import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { App_Routes } from './routes';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModule } from './app.material.module';


import { AppComponent } from './app.component';
import { MainAppComponent } from './layout/layout.component';
import { UnitsComponent } from './GlobalRegistry/units/units.component';
import { ComponentsComponent } from './GlobalRegistry/components/components.component';
import { CharacteristicsComponent } from './GlobalRegistry/Characteristics/characteristics.component';
import { TestMethodsComponent } from './ReportConfig/testmethods/testmethods.component';
import { ProductGradesListComponent } from './ReportConfig/productgrades/productgradeslist/productgradeslist.component';
import { AddProductGradesComponent } from './ReportConfig/productgrades/addproductgrades/addproductgrades.component';
import { AnalysisReportListComponent } from './ReportConfig/anaylsisreportconfig/analysisrepconfiglist/analysisrepconfig.component';
import { EditAnalysisElements } from './ReportConfig/anaylsisreportconfig/editanalysiselements/editanalysiselements.component';
import { AreaComponent } from './GlobalRegistry/Area/Area.component';

//shared
import { NoRecordsComponent } from './shared/norecords/noRecords.component';
import { CustomPager } from './shared/pagenation/pagenation.component';
import { NotFoundComponent } from './shared/404/notfound.component';
import { AuthGuard } from './common/auth.security';
import { PetroLimsAuthGuard } from './common/clientAuth.security';
import { CustomHttp } from './common/customHttp.service';
import { ApiUrl } from './common/apiUrls';
import { PagerService } from './common/pagerService';
import { ValidationService } from './common/validationservice';


import { AddedituserComponent } from './Administration/usermanagement/addedituser/addedituser.component';
import { UserlistComponent } from './Administration/usermanagement/userlist/userlist.component';
import { AddEditCustomer } from './Administration/customermanagement/addeditcustomer/addeditcustomer.component';
import { CustomerList } from './Administration/customermanagement/customerlist/customerlist.component';
import { CustomerCharsComponent } from './Administration/customermanagement/customerchars/customerchars.component';
import { AddEditLab } from './Administration/labmanagement/addeditlab/addeditlab.component';
import { LabList } from './Administration/labmanagement/lablist/lablist.component';
import { RoleList } from './Administration/rolemanagement/rolelist/rolelist.component';
import { AddEditRole } from './Administration/rolemanagement/addeditrole/addrole.component';
import { EditUserProfileSettings } from './Administration/userprofile/edituserprofilesettings/edituserprofilesettings.component';
import { UserProfileDetails } from './Administration/userprofile/userprofiledetails/userprofiledetails.component';
import { DigitalsignatureslistComponent } from './Administration/digitalsignatures/digitalsignatureslist/digitalsignatureslist.component';
import { NabllogomanageComponent } from './Administration/digitalsignatures/nabllogolist/nabllogomanage.component';
import { AddEditNablLogoComponent } from './Administration/digitalsignatures/addeditnabllogo/addeditnabllogo.component';
import { SampleStatistics } from './Reports/samplestatistics/samplestatistics.component';
import { SampleStatus } from './Analysis/samplestatus/samplestatuslist/samplestatus.component';
import { SamplesList } from './Analysis/samplestatus/samples/samples.component';
import { AddEditSampleStatus } from './Analysis/samplestatus/addsample/addsample.component';
import { ImportSampleComponent } from './Analysis/samplestatus/importsample/importsample.component';
import { AddSampleResults } from './Analysis/samplestatus/addsampleresults/addsampleresults.component';
import { AddFerroGraphySampleResults } from './Analysis/samplestatus/ferrographysampleresults/ferrographysampleresults.component';
import { ApproveSampleResults } from './Analysis/samplestatus/approvesampleresults/approvesampleresults.component';
import { ApproveFerroResults } from './Analysis/samplestatus/approveferroresults/approveferroresults.component';
import { AddEditJobCard } from './Analysis/jobcard/addeditjobcard/addeditjobcard.component';
import { JobCardList } from './Analysis/jobcard/jobcardlist/jobcardlist.component';
import { JobCardCharsComponent } from './Analysis/jobcard/jobcardchars/jobcardchars.component';
import { SendMailComponent } from './Analysis/jobcard/sendmail/sendmail.component';

import { SidenavDemo } from './pages/test/sidenav/sidenav-demo';
import { DialogComponent } from './shared/dialog/dialog.component';
import { LoginComponent } from './pages/home/login/login.component';
import { ResetpasswordComponent } from './pages/home/resetpassword/resetpassword.component';
import { ForgotpasswordComponent } from './pages/home/forgotpassword/forgotpassword.component';

import { DialogdemoComponent } from './pages/test/dialogdemo/dialogdemo.component';
import { JazzDialog, ContentElementDialog, IFrameDialog } from './pages/test/dialogdemo/dialogdemo.component';
import { StatelistComponent, AddStateDialog } from './pages/state/statelist/statelist.component';

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PaginatorComponent } from './shared/paginator/paginator.component';
import { PulishResultsListComponent } from './Analysis/publishresults/publishresultslist/publishresults.component';
import { KPIComponent } from './Reports/kpi/kpi.component';
import { GraphTemplateComponent } from './GlobalRegistry/graphtemplates/graphtemplateslist/graphtemplist.component';
import { AddEditGraphConfigComponent } from './GlobalRegistry/graphtemplates/addeditgraphconfig/addeditgraphconfig.component';
import { ConsolidatedReportComponent } from './Reports/ConsolidatedReport/ConsolidatedReport.component';

import { SamplingPoints } from './GlobalRegistry/samplingpoints/samppoints.component';
import { Equipment } from './GlobalRegistry/equipment/equipment.component';
import { SpIdComponent } from './GlobalRegistry/spid/spidlist/spid.component';
import { SpIdCharsComponent } from './GlobalRegistry/spidchars/spidchars.component';
import { AddEditSPID } from './GlobalRegistry/spid/addeditspid/addeditspid.component';
import { LubricantsListComponent } from './GlobalRegistry/LubricantChars/LubricantCharsList/lubricantcharslist.component';
import { AddLubricantCharComponent } from './GlobalRegistry/LubricantChars/AddLubricantChars/addlubricantchar.component';
import { ShipComponent } from './GlobalRegistry/ship/ship.component';
import { Recommendations } from './GlobalRegistry/Recommedations/recommendations.component';

import { DeletedData } from './Analysis/deletedsampleorjobcards/deleteddata.component';

//ck editor
import { CKEditorModule } from 'ng2-ckeditor'
import { SubmittedsampleList } from './Analysis/submittedsamples/sampleslist/submittedsamplelist.component';
import { QuillModule } from 'ngx-quill';
import { OilAnalysisReportComponent } from './Reports/oil-analysis-report/oil-analysis-report.component';
import { ChartsModule } from 'ng2-charts';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    AppComponent,
    MainAppComponent,
    NoRecordsComponent,
    CustomPager,
    NotFoundComponent,

    AddedituserComponent,
    UserlistComponent,
    AddEditCustomer,
    CustomerList,
    CustomerCharsComponent,
    AddEditLab,
    LabList,
    RoleList,
    AddEditRole,
    EditUserProfileSettings,
    UserProfileDetails,
    DigitalsignatureslistComponent,
    NabllogomanageComponent,
    AddEditNablLogoComponent,
    SampleStatistics,
    SampleStatus,
    SamplesList,
    AddEditSampleStatus,
    ImportSampleComponent,
    AddSampleResults,
    AddFerroGraphySampleResults,
    ApproveSampleResults,
    ApproveFerroResults,
    AddEditJobCard,
    JobCardList,
    JobCardCharsComponent,
    SendMailComponent,

    SidenavDemo,
    DialogComponent,
    LoginComponent,
    ForgotpasswordComponent,
    ResetpasswordComponent,

    DialogdemoComponent,
    JazzDialog, ContentElementDialog, IFrameDialog,
    AddStateDialog,
    StatelistComponent,
    DashboardComponent,
    AreaComponent,
    UnitsComponent,
    ComponentsComponent,
    CharacteristicsComponent,
    TestMethodsComponent,
    ProductGradesListComponent,
    PaginatorComponent,
    AddProductGradesComponent,
    PulishResultsListComponent,
    KPIComponent,
    GraphTemplateComponent,
    AddEditGraphConfigComponent,


    SamplingPoints,
    Equipment,
    SpIdComponent,
    AddEditSPID,
    SpIdCharsComponent,

    AnalysisReportListComponent,
    EditAnalysisElements,
    ConsolidatedReportComponent,
    LubricantsListComponent,
    AddLubricantCharComponent,
    ShipComponent,
    Recommendations,

    DeletedData,
    SubmittedsampleList,
    OilAnalysisReportComponent
  ],
  imports: [
    BrowserModule,
    MaterialModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    RouterModule.forRoot(App_Routes, { useHash: true }),
    BrowserAnimationsModule,
    ToastrModule.forRoot({ timeOut: 4000, positionClass: 'toast-top-right', preventDuplicates: true }),
    CKEditorModule,
    QuillModule,
    ChartsModule,
    MatProgressBarModule
  ],
  providers: [
    AuthGuard,
    PetroLimsAuthGuard,
    CustomHttp,
    ApiUrl,
    ValidationService,
    PagerService,


  ],
  //ForgotpasswordComponent
  entryComponents: [


    DialogComponent, ForgotpasswordComponent,
    JazzDialog, ContentElementDialog, IFrameDialog

  ],
  bootstrap: [MainAppComponent]
})
export class AppModule {
}
